import { ApiCore } from '@/services/api/utils/core.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = 'user'
const plural = 'users'
const single = 'user'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: true,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.update = (userId, params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${userId}`, params)
		.then(handleResponse)
		.catch(handleError);
}

api.getSignedUrl = (orgId, file, type) => {
	const fileToUpload = file[0];
	const fileName = fileToUpload.name.split('.')
	const extension = fileName[fileName.length - 1]
	return axios
		.get(`${apiProvider.BASE_URL}/org/${orgId}/files/signedurl/${type}/${extension}`)
		.then(handleResponse)
		.catch(handleError)
}

api.uploadFileToSignedURL = (uploadUrl, file) => {
	const fileToUpload = file[0]
	return axios.put(uploadUrl, fileToUpload, {
		transformRequest: (data, headers) => {
			delete headers.common['Authorization'];
			return data
		},
		headers: {
			'Content-Type': fileToUpload.type
		}
	})
	.then(handleResponse)
	.catch(handleError)
}

api.uploadDocumentLogo = (orgId, body) => {
	return axios
		.post(`${apiProvider.BASE_URL}/org/${orgId}/files/upload-document-logo/document-logo`, body)
		.then(handleResponse)
		.catch(handleError)
}

export default api
